// /* eslint-disable @typescript-eslint/no-unused-vars */
// import React, { useState } from "react";
// import { IconX } from "@tabler/icons-react";
// import { useForm } from "react-hook-form";
// import { useOrderCreateMutation } from "../../../apis/orderApis";
// import toast from "react-hot-toast";
// import { OrderFormData } from "../../../types/types";
// import SenderSection from "./SenderSection";
// import ReceiverSection from "./ReceiverSection";
// import ShipmentSection from "./ShipmentSection";
// import { useClientPermissions } from "../../../apis/profileApis";
// import { useSelector } from "react-redux";
// import { selectClientPermissions } from "../../../features/auth/authSlice";
// import ShipmentItemSection from "./ShipmentItemSection";

// interface AddOrdersModalsProps {
//   onClose: () => void;
//   fetchData: () => void;
// }

// const AddOrdersModal: React.FC<AddOrdersModalsProps> = ({
//   onClose,
//   fetchData,
// }) => {
//   const [step, setStep] = useState(1);
//   const [showPreview, setShowPreview] = useState(false);
//   const [useDifferentSender, setUseDifferentSender] = useState(false);

//   const { mutate: createOrder, isPending: isRequestPending } =
//     useOrderCreateMutation();

//   const { isLoading, error } = useClientPermissions();
//   const permissions = useSelector(selectClientPermissions);

//   const {
//     register,
//     setValue,
//     clearErrors,
//     formState: { errors },
//     watch,
//     control,
//     handleSubmit,
//   } = useForm<OrderFormData>({
//     mode: "onChange",
//   });

//   const handleCreate = async (data: OrderFormData) => {
//     const payload: any = {
//       type: "outlet",

//       sender: {
//         name: data.sender?.name,
//         mobile: data.sender?.mobile,
//         email: data.sender?.email,
//         dialCode: data.sender?.dialCode,
//         country: data.sender?.country,
//         countryName: data.sender?.countryName,
//         city: data.sender?.city,
//         cityName: data.sender?.cityName,
//         district: data.sender?.district,
//         iqamaNo: data.sender?.iqamaNo,
//         districtName: data.sender?.districtName,
//         zipCode: data.sender?.zipCode,
//         latitude: data.sender?.latitude,
//         longitude: data.sender?.longitude,
//         address: data.sender?.address,
//         nationalAddress: data.sender?.nationalAddress,
//       },

//       receiver: {
//         name: data.receiver?.name,
//         mobile: data.receiver?.mobile,
//         email: data.receiver?.email,
//         dialCode: data.receiver?.dialCode,
//         country: data.receiver?.country,
//         countryName: data.receiver?.countryName,
//         city: data.receiver?.city,
//         cityName: data.receiver?.cityName,
//         district: data.receiver?.district,
//         districtName: data.receiver?.districtName,
//         zipCode: data.receiver?.zipCode,
//         latitude: data.receiver?.latitude,
//         longitude: data.receiver?.longitude,
//         address: data.receiver?.address || data.receiver?.streetName || "",
//         nationalAddress: data.receiver?.nationalAddress || "",
//         streetName: data.receiver?.streetName,
//         buildingName: data.receiver?.buildingName,
//         buildingNumber: data.receiver?.buildingNumber,
//       },

//       shipment: {
//         referenceNumber: data.shipment?.referenceNumber,
//         shipmentCost: data.shipment?.shipmentCost,
//         // paymentType: data.shipment?.paymentType,

//         // ...(data.shipment?.paymentType === "COD" && {
//         //   codAmount: data.shipment?.codAmount,
//         // }),
//         numberOfPieces: data.shipment?.numberOfPieces,
//         totalWeight: data.shipment?.totalWeight,
//         serviceType: data.shipment?.serviceType,
//         shipmentType: data.shipment?.shipmentType,
//         description: data.shipment?.description,
//       },
//     };

//     createOrder(payload, {
//       onSuccess: () => {
//         setShowPreview(false);
//         onClose();
//         fetchData();
//         toast.success("Order created successfully");
//       },
//       onError: (error: any) => {
//         toast.error(error?.message || "Something went wrong");
//       },
//     });
//   };

//   return (
//     <div className="rounded-2xl  relative">
//       {/* Header */}
//       <div className="flex items-center">
//         <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
//           <h1 className="text-2xl">Create Order</h1>
//         </div>
//         <div className="relative ">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width={38}
//             height={37}
//             viewBox="0 0 38 37"
//             fill="none"
//             className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
//           >
//             <path
//               d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
//               fill="#F7F6F2"
//             />
//           </svg>

//           <button
//             onClick={onClose}
//             className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
//           >
//             <IconX size={20} />
//           </button>
//         </div>
//       </div>
//       <div className="w-full  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//         <div className=" h-[calc(100vh-16rem)] overflow-y-auto space-y-4 pt-0 p-4 px-6 scrollbar-clean">
//           <div className="grid lg:grid-cols-2 gap-4">
//             <div className="bg-[#FFFFFF] p-4  rounded-xl shadow-md">
//               <SenderSection
//                 // clients={clients}
//                 register={register}
//                 errors={errors}
//                 setValue={setValue}
//                 clearErrors={clearErrors}
//                 watch={watch}
//                 control={control}
//                 useDifferentSender={useDifferentSender}
//                 setUseDifferentSender={setUseDifferentSender}
//                 // onClientSelect={handleClientSelect}
//               />
//             </div>

//             <div className="bg-[#FFFFFF] p-4 rounded-xl shadow-md">
//               <ReceiverSection
//                 register={register}
//                 errors={errors}
//                 setValue={setValue}
//                 watch={watch}
//                 control={control}
//                 clearErrors={clearErrors}
//               />
//             </div>
//           </div>

//           <ShipmentSection
//             register={register}
//             errors={errors}
//             setValue={setValue}
//             watch={watch}
//             clearErrors={clearErrors}
//             mode="add"
//             open={true}
//             onClose={onClose}
//             setMode={() => {}}
//           />
//         </div>
//       </div>

//       <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px] ">
//         <button
//           onClick={handleSubmit(handleCreate)}
//           className={`  ${
//             isRequestPending
//               ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
//               : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
//           } flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-base font-medium`}
//         >
//           {isRequestPending && (
//             <svg
//               className="animate-spin h-5 w-5 text-white"
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//             >
//               <circle
//                 className="opacity-25"
//                 cx="12"
//                 cy="12"
//                 r="10"
//                 stroke="currentColor"
//                 strokeWidth="4"
//               />
//               <path
//                 className="opacity-75"
//                 fill="currentColor"
//                 d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
//               />
//             </svg>
//           )}
//           Generate
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AddOrdersModal;

// /* eslint-disable @typescript-eslint/no-unused-vars */
// import React, { useState } from "react";
// import { IconX, IconCheck, IconPrinter, IconDownload } from "@tabler/icons-react";
// import { useForm } from "react-hook-form";
// import { useOrderCreateMutation } from "../../../apis/orderApis";
// import toast from "react-hot-toast";
// import { OrderFormData } from "../../../types/types";
// import SenderSection from "./SenderSection";
// import ReceiverSection from "./ReceiverSection";
// import ShipmentSection from "./ShipmentSection";

// // Import New Components
// import PaymentSection from "./PaymentSection";
// import OrderSuccessPreview from "./OrderSuccessPreview";

// interface AddOrdersModalsProps {
//   onClose: () => void;
//   fetchData: () => void;
// }

// const AddOrdersModal: React.FC<AddOrdersModalsProps> = ({
//   onClose,
//   fetchData,
// }) => {
//   const [step, setStep] = useState<number>(1); // 1=Details, 2=Payment, 3=Success
//   const [useDifferentSender, setUseDifferentSender] = useState(false);
//   const [createdOrder, setCreatedOrder] = useState<any>(null);

//   const { mutate: createOrder, isPending: isRequestPending } = useOrderCreateMutation();

//   const {
//     register,
//     setValue,
//     clearErrors,
//     formState: { errors },
//     watch,
//     control,
//     handleSubmit,
//   } = useForm<OrderFormData>({
//     mode: "onChange",
//   });

//   const handleCreate = async (data: OrderFormData) => {
//     const payload: any = {
//       type: "outlet",
//       sender: {
//         name: data.sender?.name,
//         mobile: data.sender?.mobile,
//         email: data.sender?.email,
//         dialCode: data.sender?.dialCode,
//         country: data.sender?.country,
//         countryName: data.sender?.countryName,
//         city: data.sender?.city,
//         cityName: data.sender?.cityName,
//         district: data.sender?.district,
//         iqamaNo: data.sender?.iqamaNo,
//         districtName: data.sender?.districtName,
//         zipCode: data.sender?.zipCode,
//         latitude: data.sender?.latitude,
//         longitude: data.sender?.longitude,
//         address: data.sender?.address,
//         nationalAddress: data.sender?.nationalAddress,
//       },
//       receiver: {
//         name: data.receiver?.name,
//         mobile: data.receiver?.mobile,
//         email: data.receiver?.email,
//         dialCode: data.receiver?.dialCode,
//         country: data.receiver?.country,
//         countryName: data.receiver?.countryName,
//         city: data.receiver?.city,
//         cityName: data.receiver?.cityName,
//         district: data.receiver?.district,
//         districtName: data.receiver?.districtName,
//         zipCode: data.receiver?.zipCode,
//         latitude: data.receiver?.latitude,
//         longitude: data.receiver?.longitude,
//         address: data.receiver?.address || data.receiver?.streetName || "",
//         nationalAddress: data.receiver?.nationalAddress || "",
//         streetName: data.receiver?.streetName,
//         buildingName: data.receiver?.buildingName,
//         buildingNumber: data.receiver?.buildingNumber,
//       },
//       shipment: {
//         referenceNumber: data.shipment?.referenceNumber,
//         shipmentCost: data.shipment?.shipmentCost,
//         paymentType: data.shipment?.paymentType,
//         ...(data.shipment?.paymentType && data.shipment.paymentType !== "Prepaid" && {
//           codAmount: data.shipment?.codAmount,
//         }),
//         numberOfPieces: data.shipment?.numberOfPieces,
//         totalWeight: data.shipment?.totalWeight,
//         serviceType: data.shipment?.serviceType,
//         shipmentType: data.shipment?.shipmentType,
//         description: data.shipment?.description,
//       },
//     };

//     createOrder(payload, {
//       onSuccess: (response: any) => {
//         setCreatedOrder(response?.data || payload);
//         setStep(3);
//         toast.success("Order created successfully!");
//       },
//       onError: (error: any) => {
//         toast.error(error?.message || "Something went wrong");
//       },
//     });
//   };

//   const nextStep = () => setStep(2);
//   const prevStep = () => setStep(1);

//   return (
//     <div className="rounded-2xl relative">
//       {/* Header */}
//       <div className="flex items-center">
//         <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px]">
//           <h1 className="text-2xl">
//             {step === 1 && "Create Order"}
//             {step === 2 && "Payment Method at Delivery"}
//             {step === 3 && "Order Created Successfully"}
//           </h1>
//           {step < 3 && <span className="text-sm text-gray-500">Step {step} of 3</span>}
//         </div>

//         <div className="relative">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width={38}
//             height={37}
//             viewBox="0 0 38 37"
//             fill="none"
//             className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
//           >
//             <path d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z" fill="#F7F6F2" />
//           </svg>
//           <button
//             onClick={onClose}
//             className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
//           >
//             <IconX size={20} />
//           </button>
//         </div>
//       </div>

//       <div className="w-full bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//         <div className="h-[calc(100vh-16rem)] overflow-y-auto p-6 scrollbar-clean space-y-6">

//           {/* Step 1: Sender, Receiver, Shipment */}
//           {step === 1 && (
//             <>
//               <div className="grid lg:grid-cols-2 gap-4">
//                 <div className="bg-white p-4 rounded-xl shadow-md">
//                   <SenderSection
//                     register={register}
//                     errors={errors}
//                     setValue={setValue}
//                     clearErrors={clearErrors}
//                     watch={watch}
//                     control={control}
//                     useDifferentSender={useDifferentSender}
//                     setUseDifferentSender={setUseDifferentSender}
//                   />
//                 </div>
//                 <div className="bg-white p-4 rounded-xl shadow-md">
//                   <ReceiverSection
//                     register={register}
//                     errors={errors}
//                     setValue={setValue}
//                     watch={watch}
//                     control={control}
//                     clearErrors={clearErrors}
//                   />
//                 </div>
//               </div>

//               <ShipmentSection
//                 register={register}
//                 errors={errors}
//                 setValue={setValue}
//                 watch={watch}
//                 clearErrors={clearErrors}
//                 mode="add"
//                 open={true}
//                 onClose={onClose}
//                 setMode={() => {}}
//               />
//             </>
//           )}

//           {/* Step 2: Payment Method - CC or COD */}
//           {step === 2 && (
//             <PaymentSection
//               register={register}
//               errors={errors}
//               setValue={setValue}
//               watch={watch}
//               clearErrors={clearErrors}
//             />
//           )}

//           {/* Step 3: Success + Print Options */}
//           {step === 3 && createdOrder && (
//             <OrderSuccessPreview
//               order={createdOrder}
//               onClose={onClose}
//               fetchData={fetchData}
//             />
//           )}

//         </div>
//       </div>

//       {/* Footer */}
//       {step < 3 && (
//         <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-between bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
//           {step === 2 && (
//             <button onClick={prevStep} className="px-6 py-3 text-gray-600 font-medium">
//               Previous
//             </button>
//           )}

//           {step === 1 ? (
//             <button
//               onClick={nextStep}
//               className="ml-auto bg-[#FBD037] hover:bg-yellow-400 text-black rounded-full px-8 py-3 font-medium"
//             >
//               Continue to Payment
//             </button>
//           ) : (
//             <button
//               onClick={handleSubmit(handleCreate)}
//               disabled={isRequestPending}
//               className={`ml-auto flex items-center gap-2 rounded-full px-8 py-3 font-medium ${
//                 isRequestPending ? "bg-gray-800 text-white" : "bg-[#FBD037] hover:bg-yellow-400 text-black"
//               }`}
//             >
//               {isRequestPending && (
//                 <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z" />
//                 </svg>
//               )}
//               Generate Order
//             </button>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default AddOrdersModal;

/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import {
  IconX,
  IconCheck,
  IconPrinter,
  IconDownload,
} from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import { useOrderCreateMutation } from "../../../apis/orderApis";
import toast from "react-hot-toast";
import { OrderFormData } from "../../../types/types";

import SenderSection from "./SenderSection";
import ReceiverSection from "./ReceiverSection";
import ShipmentSection from "./ShipmentSection";
import PaymentSection from "./PaymentSection";
import OrderSuccessPreview from "./OrderSuccessPreview";

interface AddOrdersModalsProps {
  onClose: () => void;
  fetchData: () => void;
}

const AddOrdersModal: React.FC<AddOrdersModalsProps> = ({
  onClose,
  fetchData,
}) => {
  const [step, setStep] = useState<number>(1); // 1=Details, 2=Payment, 3=Success
  const [useDifferentSender, setUseDifferentSender] = useState(false);
  const [createdOrder, setCreatedOrder] = useState<any>(null);

  const { mutate: createOrder, isPending: isRequestPending } =
    useOrderCreateMutation();

  const {
    register,
    setValue,
    clearErrors,
    formState: { errors, isValid },
    watch,
    control,
    handleSubmit,
    trigger, // ← Added for manual validation
    reset
  } = useForm<OrderFormData>({
    mode: "onChange",
    // You can add defaultValues if needed
  });

  // Handle moving to Step 2 with validation
  const nextStep = async () => {
    // Trigger validation for all fields in Step 1
    const isStep1Valid = await trigger();

    if (isStep1Valid) {
      setStep(2);
    } else {
      toast.error(
        "Please fill all required fields correctly before continuing.",
      );

      // Optional: Scroll to first error
      const firstError = document.querySelector(".error-field");
      firstError?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const prevStep = () => setStep(1);

  const handleCreate = async (data: OrderFormData) => {
    const payload: any = {
      type: "outlet",
      sender: {
        name: data.sender?.name,
        mobile: data.sender?.mobile,
        email: data.sender?.email,
        dialCode: data.sender?.dialCode,
        country: data.sender?.country,
        countryName: data.sender?.countryName,
        city: data.sender?.city,
        cityName: data.sender?.cityName,
        district: data.sender?.district,
        iqamaNo: data.sender?.iqamaNo,
        districtName: data.sender?.districtName,
        zipCode: data.sender?.zipCode,
        latitude: data.sender?.latitude,
        longitude: data.sender?.longitude,
        address: data.sender?.address,
        nationalAddress: data.sender?.nationalAddress,
      },
      receiver: {
        name: data.receiver?.name,
        mobile: data.receiver?.mobile,
        email: data.receiver?.email,
        dialCode: data.receiver?.dialCode,
        country: data.receiver?.country,
        countryName: data.receiver?.countryName,
        city: data.receiver?.city,
        cityName: data.receiver?.cityName,
        district: data.receiver?.district,
        districtName: data.receiver?.districtName,
        zipCode: data.receiver?.zipCode,
        latitude: data.receiver?.latitude,
        longitude: data.receiver?.longitude,
        address: data.receiver?.address || data.receiver?.streetName || "",
        nationalAddress: data.receiver?.nationalAddress || "",
        streetName: data.receiver?.streetName,
        buildingName: data.receiver?.buildingName,
        buildingNumber: data.receiver?.buildingNumber,
      },
      shipment: {
        referenceNumber: data.shipment?.referenceNumber,
        shipmentCost: data.shipment?.shipmentCost,
        paymentType: data.shipment?.paymentType,
        ...(data.shipment?.paymentType &&
          data.shipment.paymentType !== "Prepaid" && {
            codAmount: data.shipment?.codAmount,
          }),
        numberOfPieces: data.shipment?.numberOfPieces,
        totalWeight: data.shipment?.totalWeight,
        serviceType: data.shipment?.serviceType,
        shipmentType: data.shipment?.shipmentType,
        description: data.shipment?.description,
      },
    };

    createOrder(payload, {
      onSuccess: (response: any) => {
        setCreatedOrder(response);
        setStep(3);
        toast.success("Order created successfully!");
      },
      onError: (error: any) => {
        toast.error(error?.message || "Something went wrong");
      },
    });
  };

  return (
    <div className="rounded-2xl relative">
      {/* Header */}
      <div className="flex items-center">
        <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px]">
          <h1 className="text-2xl">
            {step === 1 && "Create Order"}
            {step === 2 && "Payment Method at Delivery"}
            {step === 3 && "Order Created Successfully"}
          </h1>
          {step < 3 && (
            <span className="text-sm text-gray-500">Step {step} of 3</span>
          )}
        </div>

        <div className="relative">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={38}
            height={37}
            viewBox="0 0 38 37"
            fill="none"
            className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
          >
            <path
              d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
              fill="#F7F6F2"
            />
          </svg>
          <button
            onClick={onClose}
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
          >
            <IconX size={20} />
          </button>
        </div>
      </div>

      <div className="w-full bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
        <div className="h-[calc(100vh-16rem)] overflow-y-auto p-6 scrollbar-clean space-y-6">
          {step === 1 && (
            <>
              <div className="grid lg:grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-xl shadow-md">
                  <SenderSection
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    watch={watch}
                    control={control}
                    useDifferentSender={useDifferentSender}
                    setUseDifferentSender={setUseDifferentSender}
                  />
                </div>
                <div className="bg-white p-4 rounded-xl shadow-md">
                  <ReceiverSection
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    control={control}
                    clearErrors={clearErrors}
                  />
                </div>
              </div>

              <ShipmentSection
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                clearErrors={clearErrors}
                mode="add"
                open={true}
                onClose={onClose}
                setMode={() => {}}
              />
            </>
          )}

          {step === 2 && (
            <PaymentSection
              register={register}
              errors={errors}
              setValue={setValue}
              watch={watch}
              clearErrors={clearErrors}
            />
          )}

          {step === 3 && createdOrder && (
            <OrderSuccessPreview
              order={createdOrder}
              onClose={onClose}
              fetchData={fetchData}
              onCreateAnother={() => {
                reset();
                setStep(1);
                setCreatedOrder(null);
              }}
            />
          )}
        </div>
      </div>

      {/* Footer */}
      {step < 3 && (
        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-between bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
          {step === 2 && (
            <button
              onClick={prevStep}
              className="px-6 py-3 text-gray-600 font-medium hover:bg-gray-100 rounded-full transition"
            >
              ← Previous
            </button>
          )}

          {step === 1 ? (
            <button
              onClick={nextStep}
              className="ml-auto bg-[#FBD037] hover:bg-yellow-400 text-black rounded-full px-8 py-3 font-medium transition disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={!isValid} // ← This prevents moving forward if invalid
            >
              Continue to Payment
            </button>
          ) : (
            <button
              onClick={handleSubmit(handleCreate)}
              disabled={isRequestPending}
              className={`ml-auto flex items-center gap-2 rounded-full px-8 py-3 font-medium transition ${
                isRequestPending
                  ? "bg-gray-800 text-white cursor-wait"
                  : "bg-[#FBD037] hover:bg-yellow-400 text-black"
              }`}
            >
              {isRequestPending && (
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                  />
                </svg>
              )}
              Generate Order
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default AddOrdersModal;
